// extracted by mini-css-extract-plugin
export default {"primaryColor":"#642472","mainTextColorOnPrimary":"#fff","setting":"ResetProgressSettings_setting__R9ceC","resetButton":"ResetProgressSettings_resetButton__3chiL"};